module.exports = __webpack_public_path__ + "img/logobg.9c64f31d.jpg";